const SELECTORS = {
  CONTAINER: ".js-product-details-delivery-dates-container",
  SPINNER: ".js-product-details-delivery-dates-spinner",
  CONTINUE_SHOPPING_MODAL_SPINNER: ".js-continue-shopping-modal-delivery-dates-spinner",
  DELIVERY_DATES: ".js-continue-shopping-modal-delivery-dates",
  WRAPPER: ".js-product-details-delivery-dates-wrapper"
};

const setPDPDatesLoading = isLoading => {
  const $spinner = document.querySelector(SELECTORS.SPINNER);
  const $wrapper = document.querySelector(SELECTORS.WRAPPER);
  // Guard against contexts where the PDP delivery-dates DOM is not present
  // (e.g. the continue-shopping modal listener firing on non-PDP pages).
  if (!$spinner || !$wrapper) return;

  const $deliveryDates = document.querySelector(SELECTORS.DELIVERY_DATES);
  const $modalSpinner = document.querySelector(SELECTORS.CONTINUE_SHOPPING_MODAL_SPINNER);

  $spinner.classList.toggle("shown", isLoading);
  $wrapper.classList.remove("hidden");
  if ($deliveryDates) {
    $deliveryDates.classList.toggle("hidden", isLoading);
  }
  if ($modalSpinner) {
    $modalSpinner.classList.toggle("continue-shopping-modal__loading--visible", isLoading);
  }
};

export default setPDPDatesLoading;
